import session from '@/shared/session'


// initial state
const state = {
	current 	: {},
}

// getters
const getters = {
	getUser: (state) => state.current,
	isAuthenticated: state => Object.entries(state.current).length !== 0
}

// actions
const actions = {
	current ({ commit }) {
		return new Promise((resolve, reject) => {
			const token = localStorage.getItem('token')
            if (!token) {
                commit('set_user', {})
                resolve({})
                return
            }
			session.get('/api/auth/users/get_current_user/', {
                headers:{
					"Authorization":"Token "+ token,
					"Content-Type": "application/json"
                }
            }
			)
			.then(response => {
				const data = response.data
				commit('set_user', data)
				resolve(data)

			}).catch(error => {console.log(error)
				if (error.response && error.response.status === 401) {
                    // Clear invalid token
                    localStorage.removeItem('token')
                    localStorage.removeItem('username')
                }
                commit('set_user', {})
                resolve({})
			})
		})
	},
	login ({ commit }, credentials) {
		return new Promise((resolve, reject) => {
            session.post('/api/auth/login/', credentials)
                .then(response => {
					const user = response.data
					localStorage.setItem('token',response.data.token)
					localStorage.setItem('username',response.data.first_name + " " + response.data.last_name)
					commit('set_user', user)
					resolve(user)
                })
                .catch(errors => {
                    reject(errors.response.data);
                });
		})
	},

	logout ({ commit }) {
		return new Promise((resolve, reject) => {
			session.post('/api/auth/logout/')
			.then(response => {
				localStorage.removeItem('token')
				localStorage.removeItem('user')
				commit('set_user', {})
				resolve()
			})
			.catch(errors => {
				reject(errors.response.data)
			})

		})
	},

	forgotpassword ({ commit }, credentials) {
		return new Promise((resolve, reject) => {
			session.post('/api/auth/forgot-password/', credentials)
			.then(response => {
				const data = response.data
				resolve(data)
			})
			.catch(errors => {
				reject(errors.response.data)
			})

		})
	},
	resetpassword ({ commit }, credentials) {
		return new Promise((resolve, reject) => {
			session.put('/api/auth/reset-password/', credentials)
			.then(response => {
				const data = response.data
				resolve(data)
			})
			.catch(errors => {
				reject(errors.response.data)
			})

		})
	}
	
}

// mutations
const mutations = {
	set_user (state, user) {
		state.current = user
	}
}
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
